<v-public-bottom-gradient-wrapper>
  <div
    class="flex flex-col gap-10 w-[90vw] md:min-w-sm md:w-xl relative max-w-[480px]">
    @switch (errorKind()) {
      @case ('account_disabled') {
        <v-public-logo-header
          [header]="'kratosMessages.errors.account_disabled.header' | transloco"
          [subheader]="
            'kratosMessages.errors.account_disabled.subheader' | transloco
          "></v-public-logo-header>
      }
      @case ('sign_in_interrupted') {
        <v-public-logo-header
          [header]="
            'kratosMessages.errors.sign_in_interrupted.header' | transloco
          "
          [subheader]="
            'kratosMessages.errors.sign_in_interrupted.subheader' | transloco
          "></v-public-logo-header>
      }
      @case ('generic') {
        <v-public-logo-header
          [header]="'kratosMessages.errors.generic.header' | transloco"
          [subheader]="
            'kratosMessages.errors.generic.subheader' | transloco
          "></v-public-logo-header>
      }
    }

    <v-card padding="lg" variant="glass-v2">
      <div slot="body">
        @switch (errorKind()) {
          @case ('account_disabled') {
            <span>{{
              'kratosMessages.errors.account_disabled.message' | transloco
            }}</span>
          }
          @case ('sign_in_interrupted') {
            <span>{{
              'kratosMessages.errors.sign_in_interrupted.message' | transloco
            }}</span>
          }
          @case ('generic') {
            <span>{{
              'kratosMessages.errors.generic.message' | transloco
            }}</span>
          }
          @default {
            <p-skeleton height="4rem"></p-skeleton>
          }
        }

        @if (errorKind()) {
          <div class="mt-8 flex flex-wrap justify-center gap-4">
            @if (errorKind() !== 'account_disabled') {
              <v-button-v2 icon="pi pi-refresh" (press)="restartSignIn()">
                {{ 'kratosMessages.errors.restartSignInBtn' | transloco }}
              </v-button-v2>
            }
            <v-button-v2
              icon="pi pi-envelope"
              [variant]="
                errorKind() === 'account_disabled' ? 'primary' : 'outline'
              "
              (press)="openContactDetails()">
              {{ 'misc.contactSupportBtn' | transloco }}
            </v-button-v2>
          </div>
        }
      </div>
    </v-card>
  </div>
</v-public-bottom-gradient-wrapper>
